/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClass = _interopRequireDefault(require("../../react-class"));
var _Flex = require("../../Flex");
var _assign = _interopRequireDefault(require("../../../common/assign"));
var _join = _interopRequireDefault(require("../../../common/join"));
var _TimeInput = _interopRequireDefault(require("./TimeInput"));
var _Clock = _interopRequireDefault(require("./Clock"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimePicker = function (_Component) {
  (0, _inherits2.default)(TimePicker, _Component);
  var _super = _createSuper(TimePicker);
  function TimePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TimePicker);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  (0, _createClass2.default)(TimePicker, [{
    key: "render",
    value: function render() {
      var props = this.p = (0, _assign.default)({}, this.props);
      var rootClassName = props.rootClassName;
      props.children = _react.default.Children.toArray(props.children);
      var timeFormat = props.timeFormat.toLowerCase();
      props.hasTime = props.hasTime || timeFormat.indexOf('k') != -1 || timeFormat.indexOf('h') != -1;
      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
        inline: true,
        column: true,
        wrap: false
      }, this.props), {}, {
        className: className
      }), this.renderClock(), this.renderInput());
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      return _react.default.createElement(_TimeInput.default, {
        className: "".concat(this.props.rootClassName, "__time-picker-input"),
        format: this.props.timeFormat || this.props.format,
        defaultValue: this.props.value || this.props.defaultValue,
        onChange: this.onTimeChange
      });
    }
  }, {
    key: "onTimeChange",
    value: function onTimeChange(value) {
      var time = value.split(':');
      var seconds = time[0] * 3600 + parseInt(time[1], 10) * 60;
      if (time[2]) {
        seconds += parseInt(time[2], 10);
      }
      this.setState({
        seconds: seconds
      });
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "renderClock",
    value: function renderClock() {
      var props = this.p;
      var clock = props.children.filter(function (child) {
        return child && child.props && child.props.isTimePickerClock;
      })[0];
      var clockProps = {
        seconds: this.state.seconds,
        showSecondsHand: true
      };
      if (clock) {
        return _react.default.cloneElement(clock, clockProps);
      }
      return _react.default.createElement(_Clock.default, _objectSpread({}, clockProps));
    }
  }]);
  return TimePicker;
}(_reactClass.default);
exports.default = TimePicker;
TimePicker.defaultProps = {
  rootClassName: 'inovua-react-toolkit-calendar__time-picker',
  format: 'HH:mm:ss a',
  theme: 'default',
  isTimePicker: true
};
TimePicker.propTypes = {
  format: _propTypes.default.string,
  theme: _propTypes.default.string,
  isTimePicker: _propTypes.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/TimePicker.js
// module id = 636
// module chunks = 0